export default "__VITE_ASSET__DBtbW1bx__"